import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import Avatar from "../../assets/images/four.png";
import "../../Styles/Profile.css";
import { FaRegEdit, FaArrowLeft } from "react-icons/fa";
import { IoMdDocument } from "react-icons/io";
import { RiEyeLine, RiDeleteBin6Line } from "react-icons/ri";
import { Modal, Button, Form } from "react-bootstrap";
import {
  deleteEmpDoc,
  fetchEmployeeById,
} from "../../services/axios/apiManager";
import { handleErrors } from "../../services/dataManager";
import { useNavigate, useParams } from "react-router-dom";
import { baseURL } from "../../services/axios/eps";
import { addUpdateProfilePic } from "./helpers";
import { format } from "date-fns";
import { toast } from "sonner";
import { useAppContext } from "../../services/context";

const DocumentCard = ({ doc, removeDocs }) => {
  const [modalOptions, setModalOptions] = useState({});
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const handleDeleteEmpDoc = () => {
    setModalOptions({
      header: "Delete Employee Document",
      body: `Are you sure you want to delete employee document"?`,
      okay: "Delete",
      method: deleteEmployeeDoc,
    });
    setShowOptionsModal(true);
  };
  const deleteEmployeeDoc = async () => {
    const res = await deleteEmpDoc(doc.id);
    if (res?.data?.success) {
      removeDocs(doc.id);
      toast.success("Document has been deleted");
      setModalOptions({});
      setShowOptionsModal(false);
    }
  };
  const handleCloseOptionsModal = () => {
    setModalOptions({});
    setShowOptionsModal(false);
  };
  return (
    <div
      className="card bg-dark text-white p-3 d-flex flex-row align-items-center justify-content-between shadow-lg"
      style={{ width: "300px", height: "80px" }}
    >
      <div className="d-flex align-items-center">
        <IoMdDocument size={30} className="text-[#038f5e]" />
        <span className="text-truncate" style={{ maxWidth: "180px" }}>
          {`${doc?.document_name} (${doc?.document_type})`}
        </span>
      </div>
      <div className="d-flex flex-row align-items-center">
        <a
          href={`${baseURL}uploads/file/${doc?.document_url}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <RiEyeLine size={20} className="text-info" role="button" />
        </a>
        <button
          className="ml-1"
          onClick={() => {
            handleDeleteEmpDoc();
          }}
        >
          <RiDeleteBin6Line size={20} className="text-danger" role="button" />
        </button>
      </div>
      <Modal
        show={showOptionsModal}
        onHide={handleCloseOptionsModal}
        centered
        className="text-light"
      >
        <Modal.Header closeButton className="bg-dark text-light border-0">
          <Modal.Title>{modalOptions.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark text-light">
          {modalOptions.body}
        </Modal.Body>
        <Modal.Footer className="bg-dark text-light border-0">
          <Button variant="secondary" onClick={handleCloseOptionsModal}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              modalOptions.method(modalOptions.data);
            }}
          >
            {modalOptions.okay}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

function ViewGame({ name }) {
  const { id } = useParams();
  const { state } = useAppContext();
  const { permissions } = state;
  const [activeTab, setActiveTab] = useState("#basicInfo");
  const navigate = useNavigate();
  const [empData, setEmpData] = useState(null);
  const [imageURL, setImageURL] = useState(null);
  const [granted, setGranted] = useState([]);

  const extractPermissions = () => {
    const perms = permissions?.filter((f) => f.module === "Employees");
    if (perms) {
      setGranted(perms);
    }
  };

  const handleTabChange = (e) => {
    e.preventDefault();
    setActiveTab(e.target.getAttribute("href"));
  };

  const handleImageChange = async (e) => {
    e.preventDefault();
    if (e?.target?.files && e.target.files[0]) {
      const file = e.target.files[0];
      await addUpdateProfilePic(id, file, navigate);
      const previewUrl = URL.createObjectURL(file);
      setImageURL(previewUrl);
    } else {
      setImageURL(null);
    }
  };

  const handleEditProfile = () => {
    if (!granted?.some((g) => g?.type === "update")) {
      toast.error(
        "You don't have neccessary permissions to do this operation!",
        { duration: 3000 }
      );
      return;
    }
    let tab = "";
    if (activeTab === "#securityPrivacy") {
      tab = "basicInfo";
    } else {
      tab = activeTab.replace("#", "");
    }
    navigate(`/AddEditEmployee/${tab}/${id}`, { state: { fromProfile: true } });
  };

  const getEmployeeData = async () => {
    const res = await fetchEmployeeById(id);
    if (res?.data?.success && res?.data?.data) {
      setEmpData(res.data.data);
    } else {
      handleErrors(res, navigate, "Employee Profile:");
    }
  };

  const removeDocs = async (id) => {
    const temp = { ...empData };
    const docs = temp?.Emp_Docs?.filter((f) => f.id !== id);
    temp.Emp_Docs = docs;
    setEmpData(temp);
  };

  useEffect(() => {
    extractPermissions();
    getEmployeeData();
  }, []);

  return (
    <DashboardLayout>
      <div>
        <div>
          <div>
            <div>
              <div className="card overflow-hidden">
                <div>
                  <img
                    src={Avatar}
                    alt=""
                    className="card-img-top profile-wid-img object-fit-cover"
                    style={{ height: 200 }}
                  />
                  <div className="position-absolute end-0 top-0 m-3"></div>
                </div>
                <div className="card-body pt-0 mt-[-2rem]">
                  <div className="text-center">
                    <div className="profile-user position-relative d-inline-block mx-auto">
                      <img
                        crossorigin="anonymous"
                        src={
                          imageURL
                            ? imageURL
                            : empData?.image
                              ? `${baseURL}/uploads/file/${empData.image}`
                              : require("../../assets/images/t-one.png")
                        }
                        alt="Employee Avatar"
                        className="img-fluid center avatar-lg rounded-circle object-fit-cover img-thumbnail user-profile-image"
                        style={{
                          maxHeight: "200px",
                          minHeight: "150px",
                          width: "150px",
                          border: "5px solid #ccc",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <div className="mt-3">
                      <h5 className="mb-0">
                        {`${empData?.first_name || ""} ${empData?.last_name || ""}`}
                        <i className="bi bi-patch-check-fill align-baseline text-info ms-1" />
                      </h5>
                    </div>
                  </div>
                </div>
                <div
                  className="col-xxl-12 card p-4 rounded text-light"
                  style={{ border: "none", background: "#0a1117" }}
                >
                  <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div className="d-flex align-items-center flex-grow-1">
                      <ul
                        className="nav nav-pills arrow-navtabs nav-secondary gap-2 flex-grow-1 order-2 order-lg-1"
                        role="tablist"
                      >
                        {[
                          { href: "#basicInfo", label: "Personal Details" },
                          { href: "#companyInfo", label: "Company Info" },
                          { href: "#serviceInfo", label: "Service Info" },
                          { href: "#documents", label: "Documents" },
                          { href: "#securityPrivacy", label: "Others" },
                        ].map((tab) => (
                          <li
                            className="nav-item"
                            role="presentation"
                            key={tab.href}
                          >
                            <a
                              className={`nav-link ${activeTab === tab.href ? "active" : ""}`}
                              data-bs-toggle="tab"
                              role="tab"
                              href={tab.href}
                              onClick={handleTabChange}
                            >
                              {tab.label}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="ms-auto d-flex">
                      <button
                        className="btn btn-secondary d-flex align-items-center gap-2 me-2"
                        onClick={() => navigate("/employees")}
                      >
                        <FaArrowLeft className="me-1" />
                        Go Back
                      </button>
                      <button
                        className="btn btn-success d-flex align-items-center gap-2"
                        onClick={() => {
                          handleEditProfile();
                        }}
                      >
                        <FaRegEdit className="me-1" />
                        Edit Profile
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* /////////////////////////////////////////////////////// */}
              <div>
                <div className="tab-content mt-4">
                  <>
                    <div
                      className="tab-pane active"
                      id="basicInfo"
                      role="tabpanel"
                    >
                      <div className="card shadow-lg border-0 rounded-4">
                        <div className="card-header bg-dark text-white py-3">
                          <h5
                            className="card-title mb-0 fs-4 fw-bold"
                            data-testid="basicInfo"
                          >
                            Personal Details
                          </h5>
                        </div>

                        <div className="card-body bg-dark text-white">
                          <div className="row g-4">
                            {[
                              {
                                label: "First Name",
                                value: empData?.first_name || "",
                              },
                              {
                                label: "Last Name",
                                value: empData?.last_name || "",
                              },
                              {
                                label: "Email Address",
                                value: empData?.email || "",
                              },
                              {
                                label: "Mobile Number",
                                value: empData?.mobile_number || "",
                              },
                              {
                                label: "Landline Number",
                                value: empData?.landline_number || "",
                              },
                              {
                                label: "Birth Date",
                                value:
                                  (empData?.date_of_birth &&
                                    format(empData.date_of_birth, "PP")) ||
                                  "",
                              },
                              {
                                label: "Gender",
                                value: empData?.gender || "",
                              },
                              {
                                label: "Emergency Contact Name",
                                value: empData?.emergency_contact_name || "",
                              },
                              {
                                label: "Emergency Contact Number",
                                value: empData?.emergency_contact_number || "",
                              },
                            ].map((item, index) => (
                              <div className="col-lg-6" key={index}>
                                <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                  <span className="text-secondary fs-6 fw-semibold">
                                    {item.label}
                                  </span>
                                  <span
                                    className={`d-block fs-5 fw-medium ${!item.value && "text-danger"}`}
                                  >
                                    {item.value || "N/A"}
                                  </span>
                                </div>
                              </div>
                            ))}
                            <div className="col-lg-12">
                              <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                <span className="text-secondary fs-6 fw-semibold">
                                  Address
                                </span>
                                <span className="d-block fs-5 fw-medium">
                                  {empData?.address_line_1 ||
                                  empData?.address_line_2
                                    ? `${empData?.address_line_1 || ""}, ${empData?.address_line_2 || ""}`
                                    : "N/A"}
                                </span>
                              </div>
                            </div>
                            {[
                              {
                                label: "Country",
                                value: empData?.country?.country_name || "",
                              },
                              {
                                label: "Province",
                                value: empData?.province?.province_name || "",
                              },
                              {
                                label: "City",
                                value: empData?.city?.city_name || "",
                              },
                              {
                                label: "Zip Code",
                                value: empData?.zip_code || "",
                              },
                            ].map((item, index) => (
                              <div className="col-lg-6" key={index}>
                                <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                  <span className="text-secondary fs-6 fw-semibold">
                                    {item.label}
                                  </span>
                                  <span
                                    className={`d-block fs-5 fw-medium ${!item.value && "text-danger"}`}
                                  >
                                    {item.value || "N/A"}
                                  </span>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="tab-pane" id="companyInfo" role="tabpanel">
                      <div className="card shadow-lg border-0 rounded-4">
                        <div className="card-header bg-dark text-white py-3">
                          <h5
                            className="card-title mb-0 fs-4 fw-bold"
                            data-testid="companyInfo"
                          >
                            Company Information
                          </h5>
                        </div>

                        <div className="card-body bg-dark text-white">
                          <div className="row g-4">
                            {/* Employee Details */}
                            {[
                              {
                                label: "Employee ID",
                                value: empData?.id || "",
                              },
                              {
                                label: "Role",
                                value: empData?.role?.name.toUpperCase() || "",
                              },
                              {
                                label: "Department",
                                value: empData?.department?.name || "",
                              },
                              {
                                label: "Designation",
                                value: empData?.designation?.title || "",
                              },
                            ].map((item, index) => (
                              <div className="col-lg-6" key={index}>
                                <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                  <span className="text-secondary fs-6 fw-semibold">
                                    {item.label}
                                  </span>
                                  <span
                                    className={`d-block fs-5 fw-medium ${!item.value && "text-danger"}`}
                                  >
                                    {item.value || "N/A"}
                                  </span>
                                </div>
                              </div>
                            ))}

                            {/* Financial Information Section */}
                            <div className="col-lg-12">
                              <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                <span className="text-secondary fs-5 fw-bold d-block mb-2">
                                  Financial Information
                                </span>
                                <div className="row g-3">
                                  {[
                                    {
                                      label: "Basic Salary",
                                      value:
                                        empData?.FinancialInfo?.basic_salary ||
                                        "",
                                    },
                                    {
                                      label: "Gross Salary",
                                      value:
                                        empData?.FinancialInfo?.gross_salary ||
                                        "",
                                    },
                                    {
                                      label: "Per Hourly Rate",
                                      value:
                                        empData?.FinancialInfo?.hourly_rate ||
                                        "",
                                    },
                                    {
                                      label: "Bank Account Title",
                                      value:
                                        empData?.FinancialInfo
                                          ?.bank_account_title || "",
                                    },
                                    {
                                      label: "IBAN",
                                      value: empData?.FinancialInfo?.IBAN || "",
                                    },
                                  ].map((item, index) => (
                                    <div className="col-lg-6" key={index}>
                                      <div className="p-3 bg-secondary bg-opacity-25 rounded">
                                        <span className="text-secondary fs-6 fw-semibold">
                                          {item.label}
                                        </span>
                                        <span
                                          className={`d-block fs-5 fw-medium ${!item.value && "text-danger"}`}
                                        >
                                          {item.value || "N/A"}
                                        </span>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="tab-pane" id="serviceInfo" role="tabpanel">
                      <div className="card shadow-lg border-0 rounded-4">
                        <div className="card-header bg-dark text-white py-3">
                          <h5
                            className="card-title mb-0 fs-4 fw-bold"
                            data-testid="serviceInfo"
                          >
                            Service Information
                          </h5>
                        </div>

                        <div className="card-body bg-dark text-white">
                          <div className="row g-4">
                            {/* Service Info Details */}
                            {[
                              {
                                label: "Hiring Date",
                                value:
                                  (empData?.hiring_date &&
                                    format(empData.hiring_date, "PP")) ||
                                  "",
                              },
                              {
                                label: "Confirmation Date",
                                value:
                                  (empData?.confirmation_date &&
                                    format(empData.confirmation_date, "PP")) ||
                                  "",
                              },
                              {
                                label: "Joining Date",
                                value:
                                  (empData?.joining_date &&
                                    format(empData.joining_date, "PP")) ||
                                  "",
                              },
                              {
                                label: "Regular Date",
                                value:
                                  (empData?.regular_date &&
                                    format(empData.regular_date, "PP")) ||
                                  "",
                              },
                              {
                                label: "Probation End Date",
                                value:
                                  (empData?.probation_end_date &&
                                    format(empData.probation_end_date, "PP")) ||
                                  "",
                              },
                              {
                                label: "Left Date",
                                value:
                                  (empData?.left_date &&
                                    format(empData.left_date, "PP")) ||
                                  "",
                              },
                            ].map((item, index) => (
                              <div className="col-lg-6" key={index}>
                                <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                  <span className="text-secondary fs-6 fw-semibold">
                                    {item.label}
                                  </span>
                                  <span
                                    className={`d-block fs-5 fw-medium ${!item.value && "text-danger"}`}
                                  >
                                    {item.value || "N/A"}
                                  </span>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="tab-pane" id="documents" role="tabpanel">
                      <div className="card shadow-lg border-0 rounded-4 bg-dark text-white">
                        <div className="card-header bg-dark text-white py-3 border-bottom border-secondary">
                          <h5
                            className="card-title mb-0 fs-4 fw-bold"
                            data-testid="documents"
                          >
                            Employee Documents
                          </h5>
                        </div>
                        <div className="card-body p-4">
                          <div className="d-flex gap-3 justify-content-start flex-wrap">
                            {empData?.Emp_Docs?.length > 0 ? (
                              empData.Emp_Docs.map((doc, index) => (
                                <DocumentCard
                                  key={index}
                                  doc={doc}
                                  removeDocs={removeDocs}
                                />
                              ))
                            ) : (
                              <p className="text-light fst-italic">
                                No documents available
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="tab-pane text-light"
                      id="securityPrivacy"
                      role="tabpanel"
                    >
                      <div className="card shadow-lg border-0 rounded-4">
                        <div className="card-header bg-dark text-white">
                          {/* Card Header */}
                          <div className="card-header bg-dark text-white border-bottom border-secondary">
                            <h5
                              className="card-title mb-0 fs-4 fw-bold"
                              data-testid="securityPrivacy"
                            >
                              Others
                            </h5>
                          </div>

                          <div className="card-body">
                            <div className="row">
                              {[
                                {
                                  item: "Logged-In",
                                  value:
                                    empData?.is_logged_in === 1 ? "Yes" : "No",
                                },
                                {
                                  item: "Registered By",
                                  value: "Email",
                                },
                                {
                                  item: "Last Logged-In",
                                  value:
                                    (empData?.last_logged_in &&
                                      format(empData.last_logged_in, "PPpp")) ||
                                    "",
                                },
                                {
                                  item: "Last Logged-Out",
                                  value:
                                    (empData?.last_logged_out &&
                                      format(
                                        empData.last_logged_out,
                                        "PPpp"
                                      )) ||
                                    "",
                                },
                                {
                                  item: "Updated By",
                                  value: `${empData?.emp_updated_by?.first_name || ""} ${empData?.emp_updated_by?.last_name || ""}`,
                                },
                                {
                                  item: "Created At",
                                  value:
                                    (empData?.createdAt &&
                                      format(empData.createdAt, "PP")) ||
                                    "",
                                },
                                {
                                  item: "Updated At",
                                  value:
                                    (empData?.updatedAt &&
                                      format(empData.updatedAt, "PP")) ||
                                    "",
                                },
                                {
                                  item: "Deleted At",
                                  value:
                                    (empData?.deletedAt &&
                                      format(empData.deletedAt, "PP")) ||
                                    "",
                                },
                              ].map((emp) => (
                                <div className="col-lg-6 mb-3">
                                  <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                    <span className="text-secondary fs-6 fw-semibold">
                                      {emp.item}
                                    </span>
                                    <span
                                      className={`d-block fs-5 fw-medium ${!emp?.value && "text-danger"}`}
                                    >
                                      {emp?.value || "N/A"}
                                    </span>
                                  </div>
                                </div>
                              ))}
                              {/* <div className="col-lg-6 mb-3">
                                <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                  <span className="text-secondary fs-6 fw-semibold">
                                    Last Logged-Out
                                  </span>
                                  <span className="d-block fs-5 fw-medium">
                                    2nd Feb, 2025
                                  </span>
                                </div>
                              </div>
                              <div className="col-lg-6 mb-3">
                                <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                  <span className="text-secondary fs-6 fw-semibold">
                                    Logged-in
                                  </span>
                                  <span className="d-block fs-5 fw-medium">
                                    Yes
                                  </span>
                                </div>
                              </div>
                              <div className="col-lg-6 mb-3">
                                <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                  <span className="text-secondary fs-6 fw-semibold">
                                    Logged-in From
                                  </span>
                                  <span className="d-block fs-5 fw-medium">
                                    Email
                                  </span>
                                </div>
                              </div>
                              <div className="col-lg-6 mb-3">
                                <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                  <span className="text-secondary fs-6 fw-semibold">
                                    Register From
                                  </span>
                                  <span className="d-block fs-5 fw-medium">
                                    Google
                                  </span>
                                </div>
                              </div>
                              <div className="col-lg-6 mb-3">
                                <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                  <span className="text-secondary fs-6 fw-semibold">
                                    Updated By
                                  </span>
                                  <span className="d-block fs-5 fw-medium">
                                    Admin
                                  </span>
                                </div>
                              </div>
                              <div className="col-lg-6 mb-3">
                                <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                  <span className="text-secondary fs-6 fw-semibold">
                                    Created At
                                  </span>
                                  <span className="d-block fs-5 fw-medium">
                                    30th Oct, 2015
                                  </span>
                                </div>
                              </div>
                              <div className="col-lg-6 mb-3">
                                <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                  <span className="text-secondary fs-6 fw-semibold">
                                    Updated At
                                  </span>
                                  <span className="d-block fs-5 fw-medium">
                                    5th Feb, 2025
                                  </span>
                                </div>
                              </div>
                              <div className="col-lg-6 mb-3">
                                <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                  <span className="text-secondary fs-6 fw-semibold">
                                    Deleted At
                                  </span>
                                  <span className="d-block fs-5 fw-medium">
                                    N/A
                                  </span>
                                </div>
                              </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default ViewGame;
